"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowNumericEditor_1 = require("../../components/editors/CardRowNumericEditor");
var DlgNumericEditor = /** @class */ (function (_super) {
    __extends(DlgNumericEditor, _super);
    function DlgNumericEditor(props) {
        return _super.call(this, props) || this;
    }
    DlgNumericEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                value: data.value,
                visible: data.visible,
                minValue: data.minValue,
                maxValue: data.maxValue,
                dialogTitle: data.title,
                digitsCount: data.digitsCount,
                inputCaption: data.inputCaption,
                inputPlaceHolder: data.inputPlaceHolder
            });
        });
        this.doReSetRules();
    };
    DlgNumericEditor.prototype.doReSetRules = function () {
        this.setState({
        //value_rules: {isError: false },
        });
    };
    DlgNumericEditor.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgNumericEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        return true;
    };
    DlgNumericEditor.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.value);
            }
        }
    };
    DlgNumericEditor.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgNumericEditor.prototype.render = function () {
        var _this = this;
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: false, maskClosable: false, okType: "primary", style: { minWidth: 500 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowNumericEditor_1.default, { texts: { caption: this.state.inputCaption, placeholder: this.state.inputPlaceHolder }, values: { max: this.state.maxValue, min: this.state.minValue, value: this.state.value }, onValueChanged: function (newVal) { _this.setState({ value: newVal }); }, precision: this.state.digitsCount })));
    };
    return DlgNumericEditor;
}(React.Component));
exports.default = DlgNumericEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgNumericEditor.tsx
// module id = 2486
// module chunks = 0